export default __webpack_public_path__ + "49fd632a2874fbf4413347616ba0100e.png";